import React from "react";
import image from "../assets/images/coin.jpg";
import TopHeader from "../components/TopHeader";
import ContactForm from "../components/ContactForm";
import InfoCard from "../components/InfoCard";

const ContactUs = () => {
  return (
    <section className="bg-gray-100 min-h-screen pb-8">
      {/* Header */}
      <div
        className="relative bg-cover bg-center h-100 items-center flex justify-center"
        style={{ backgroundImage: `url(${image})` }}
      >
        <div className="absolute inset-0 bg-black/50"></div>
        <TopHeader title="contact us" subtitle="contact us" />
      </div>
      <div className="bg-white max-w-6xl mx-auto w-full p-4">
        <ContactForm />
        <InfoCard />
      </div>
    </section>
  );
};

export default ContactUs;
